module.exports = __webpack_public_path__ + "img/used-car-mitsubishi-lancer-x.2806a800.jpg";